<template>
  <!--
          作者：luoyiming
          时间：2019-10-24
          描述：统计-销售统计-商品统计-汇总
      -->
  <div class="d-a-c lh30 ww100 pt16">
    <div class="pt30 tc" style="width: 80px;">
      <p class="gray9">今日</p>
      <p class="gray9">昨日</p>
    </div>
    <div class="flex-1 tc">
      <p class="lh30">在售商品</p>
      <p class="f20 fb gray3">{{dataModel.product?dataModel.product.sale.today:0}}</p>
      <p class="gray">{{dataModel.product?dataModel.product.sale.yesterday:0}}</p>
    </div>
    <div class="flex-1 tc">
      <p>未付款商品(件)</p>
      <p class="f20 fb gray3">{{dataModel.product?dataModel.product.no_pay.today:0}}</p>
      <p class="gray">{{dataModel.product?dataModel.product.no_pay.yesterday:0}}</p>
    </div>
    <div class="flex-1 tc">
      <p>已付款商品(件)</p>
      <p class="f20 fb gray3">{{dataModel.product?dataModel.product.pay.today:0}}</p>
      <p class="gray">{{dataModel.product?dataModel.product.pay.yesterday:0}}</p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: true
    };
  },
  inject: ["dataModel"],
  created() {
    console.log("===========", this.dataModel);
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/statistics/sales/part/product/Total.vue